import { AuthService } from '../../../services/auth/auth.service';
import {
  Component,
  OnInit,
  SimpleChanges,
  OnChanges,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import {
  ItemsDetailsService,
  ItemsFromOtherLibraries,
  LoanItem,
} from '../../../pages/item-details/item-details.service';

@Component({
  selector: 'guest-ill-tracking',
  templateUrl: './guest-ill-tracking.component.html',
  styleUrls: ['./guest-ill-tracking.component.scss'],
  providers: [{ provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GuestIllTrackingComponent implements OnInit, OnChanges {
  @Input() tracking: any;

  loading = true;
  guestForm: UntypedFormGroup;
  page1: boolean;
  requests: ItemsFromOtherLibraries;
  items: LoanItem[];
  limitMessage: string;

  private _itemDetailsService = inject(ItemsDetailsService);
  private _authService = inject(AuthService);
  private _fb = inject(UntypedFormBuilder);
  snackBar = inject(MatSnackBar);

  ngOnInit() {
    // this.loading = true;
    this.guestForm = this._fb.group({
      Username: ['', Validators.required],
      Password: ['', Validators.required],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes) {
      if (changes.tracking) {
        this.tracking = changes.tracking.currentValue;
        this.loading = false;
        this.page1 = true;
        // empty the form
        if (this.guestForm) {
          this.guestForm.reset();
        }
      }
    }
  }

  submitForm(form) {
    // call api here
    const body = {
      username: form.value.Username,
      password: form.value.Password,
      sortBy: '',
    };

    this._authService.getGuestIllReq(body).subscribe((response) => {
      if (response.status == '200 OK') {
        this.requests = response.data;
        this.items = []
          .concat(this.requests.items.active)
          .concat(this.requests.items.complete.filter((item) => item.requestType === 'cpy'));
        this.page1 = false;
        this.limitMessage = this._itemDetailsService.limitMessage(response.data.patronIllLimit);
      }
    });
  }

  back() {
    this.page1 = true;
    this.items = [];
  }

  onNavigate(URL) {
    window.open(URL, '_blank', 'location=yes,height=650,width=650,scrollbars=yes,status=yes');
  }

  // snackbar alert
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }
}
